import ScormAPI from '@/lib/ScormApi/ScormAPI'
import JsonFormatter from '@/lib/ScormApi/JsonFormatter'
import CMI_InteractionsObjectivesObjectInterface
  from "@/lib/ScormApi/Scorm/interfaces/CMI_InteractionsObjectivesObjectInterface"

export default function CMI_InteractionsObjectivesObject (API: ScormAPI): CMI_InteractionsObjectivesObjectInterface {
  const jsonString = true
  let _id = ''
  return {
    get id (): any {
      return (!jsonString) ? API.throwSCORMError(404) : _id
    },
    set id (id) {
      _id = id
    },
    toJSON: new JsonFormatter().apply
  }
}
